module.exports = __webpack_public_path__ + "img/logo_busd.99eb3825.png";